import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './theme/tokens.css';
import './theme/base.css';

// Font-loading canary — verifies Noto Serif Tamil actually resolved for
// each weight we ship and can render a Tamil glyph. We explicitly
// ``load()`` each weight before ``check()`` so the canary doesn't race
// with the CDN response (``document.fonts.ready`` only awaits fonts
// pending at the moment it's first read).
if (typeof document !== 'undefined' && 'fonts' in document) {
    const CANARY = 'அ';
    const WEIGHTS = ['500', '700'] as const;
    Promise.all(
        WEIGHTS.map((w) => document.fonts.load(`${w} 16px "Noto Serif Tamil"`, CANARY))
    ).then(() => {
        const missing = WEIGHTS.filter(
            (w) => !document.fonts.check(`${w} 16px "Noto Serif Tamil"`, CANARY)
        );
        if (missing.length > 0) {
            // eslint-disable-next-line no-console
            console.warn(
                `[thirukkural-ui] Noto Serif Tamil failed to load at weights: ${missing.join(', ')} — Tamil text may render in a fallback face.`
            );
        }
    });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
